import { Component, ViewChild } from '@angular/core';
import {IonicPage, NavController, NavParams, MenuController, Slides, Events} from 'ionic-angular';

import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

import { InAppBrowser } from '@ionic-native/in-app-browser';

import { FileOpener } from '@ionic-native/file-opener';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
import { LoadingProvider } from '../../providers/loading';

import * as moment from "moment";

import {NewsReadPage} from "../news-read/news-read";
import {EventsDetailsPage} from "../events-details/events-details";
/**
 * Generated class for the MagazinePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-magazine',
    templateUrl: 'magazine.html',
})
export class MagazinePage {

    title: string = 'CMS';
    pdf_path: string = 'https://app.fw-wesling.de/uploads/documents/';

    page_boxes: any;
    page_id: number;

    disable_menu: boolean = false;
    disable_user_menu: boolean = false;

    enable_guest_menu: boolean = false;

    @ViewChild('slides') slides: Slides;
    constructor(public events: Events, public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, private transfer: FileTransfer, private file: File, private fileOpener: FileOpener, public loadingProvider: LoadingProvider, public menuCtrl: MenuController, private iab: InAppBrowser) {

        this.page_id = this.navParams.get("page");
        this.title = this.navParams.get("title");
        this.disable_menu = this.navParams.get("disable_menu");
        this.disable_user_menu = this.navParams.get("disable_user_menu");
        this.enable_guest_menu = this.navParams.get("enable_guest_menu");

        console.log(this.page_id);
        this.loadPage();

    }


    ionViewDidLoad() {
        console.log('ionViewDidLoad CmsPage');
    }


    loadPage() {
        this.teamappProvider.http_request('page='+this.page_id, 'cms', false, true).then(data => {

            let cmsData: any = data;
            if(!cmsData.error) {
                this.page_boxes = cmsData;
            }
            console.log(this.page_boxes);
        });
    }

    ionViewDidEnter() {
        // the root left menu should be disabled on this page
        if(this.enable_guest_menu == true) {
            this.menuCtrl.enable(false, 'main-menu');
            this.menuCtrl.enable(true, 'guest-menu');
        }

    }

    ionViewWillLeave() {
        if(this.enable_guest_menu == true) {
            this.menuCtrl.enable(true, 'main-menu');
            this.menuCtrl.enable(false, 'guest-menu');
        }
    }

    openPDF(document_name,box_id, fileUrl){
        const fileTransfer: FileTransferObject = this.transfer.create();
        console.log(this.pdf_path + fileUrl);
        console.log(this.file.dataDirectory + document_name+'-'+box_id+'.pdf');
        this.loadingProvider.show();
        fileTransfer.download(this.pdf_path + fileUrl, this.file.dataDirectory + document_name+'-'+box_id+'.pdf').then((entry) => {
            this.fileOpener.open(entry.toURL(), 'application/pdf')
                .then(() => console.log('File is opened'))
                .catch(e => console.log('Error opening file', e));
            this.loadingProvider.hide();
        }, (error) => {
            this.loadingProvider.hide();
        });
    }

    goToPage(pageId: any, page_title: string) {
        this.navCtrl.push(MagazinePage,{page: pageId, disable_menu: this.disable_menu, disable_user_menu: this.disable_user_menu, enable_guest_menu: this.enable_guest_menu, title: page_title});
    }

    goToWebsite(link: string) {
        this.iab.create(link, '_blank');
    }

    refreshPage(event:any) {
        this.loadPage();
        event.complete();
    }

    formatNewsDate(date: any) {
        return moment(date).format('DD.MM.YYYY');
    }

    formatEventDate(date: any) {
        return moment(date).format('DD.MM.YYYY');
    }

    openNews(news: any) {
        console.log(news);
        if(news.type == 'rss') {
            this.iab.create(news.link, '_blank');
        } else if(news.type == 'own') {
            console.log("news");
            console.log(news);
            this.navCtrl.push(NewsReadPage,{news: news});
        }
    }

    openModulePage(title: string, page:string, parameters: any) {
        this.events.publish('app:changepage',page, title, parameters);
    }

    openEvent(e: any) {
        this.navCtrl.push(EventsDetailsPage, {details: e})  ;
    }

    next() {
        this.slides.slideNext();
    }

    prev() {
        this.slides.slidePrev();
    }

}



// WEBPACK FOOTER //
// ./src/pages/magazine/magazine.ts